import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import MaterialTheme from "./theme";
import React from "react";
import { applyInitialTheme } from "./theme/apply-theme";

import BaseRouteWrapper from "./baseRouteWrapper";

// Paint the cached hotel theme (or the defaults) before the first render, so the loader shown while hotel details
// load already uses it. MaterialTheme re-applies the fresh webapptheme once they arrive.
applyInitialTheme();
const container = document.getElementById("root");
var triggerMixpanelInitialVisit = false;
const root = createRoot(container);
console.log(document.referrer, "document.referrer");


const isWebflowWebView = window.location.pathname.includes("webflowWebView");
console.log("isWebflowWebView:", isWebflowWebView);

if (!isWebflowWebView && !window.localStorage.getItem("PUSHTELL-bookingEngine")) {
  triggerMixpanelInitialVisit = true;
  console.log("index", typeof window.localStorage);
}


root.render(
  <Provider store={store}>
    <MaterialTheme>
      <BaseRouteWrapper
        triggerMixpanelInitialVisit={triggerMixpanelInitialVisit}
      />
    </MaterialTheme>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
